/**
 * AppRoot — single entry point of the application.
 *
 * Wraps the legacy App in the full provider stack (theme, router, store,
 * i18n, notifications, auth, etc.). Over time the routing will move into
 * app/router/ and individual pages into pages/, but the entry point (this
 * file) stays the same — consumers just render <AppRoot /> from src/index.js.
 */
import AppProviders from './providers/AppProviders';
import LegacyApp from '_legacy/components/App/App';

const AppRoot = () => (
  <AppProviders>
    <LegacyApp />
  </AppProviders>
);

export default AppRoot;
